import { Box, styled } from '@mui/material';

export const LoaderBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;
